<div class="card">
	<div class="card-header border-0 pt-6">
		<div class="card-title">
			<h3 class="card-title align-items-start flex-column">
				<span class="card-label fw-bold fs-3 mb-1">Payment Allocations</span>
				<span class="text-muted mt-1 fw-semibold fs-7" *ngIf="clientData">
					{{ getCustomerDisplayName(clientData) }}
				</span>
			</h3>
		</div>
		<div class="card-toolbar">
			<div class="d-flex align-items-center">
				<!-- Filter Button -->
				<button type="button"
						class="btn btn-light btn-sm me-3"
						(click)="toggleFilterSection()">
					<i class="ki-duotone ki-magnifier fs-2">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
					Search
				</button>

				<!-- Customer Search -->
				<div class="position-relative" style="min-width: 300px;">
					<input
						type="text"
						class="form-control form-control-sm"
						placeholder="Search Customer..."
						[(ngModel)]="customerSearchTerm"
						(input)="onCustomerSearchInput($event)"
						(focus)="onCustomerInputFocus()"
						(blur)="onCustomerInputBlur()"
						autocomplete="off" />

					<!-- Search Results Dropdown -->
					<div class="dropdown-menu show w-100 mh-300px overflow-auto"
						 *ngIf="showCustomerDropdown && (customerSearchResults.length > 0 || isCustomerSearching)">

						<!-- Loading State -->
						<div class="dropdown-item text-center py-3" *ngIf="isCustomerSearching">
							<span class="spinner-border spinner-border-sm me-2"></span>
							Searching customers...
						</div>

						<!-- Search Results -->
						<a class="dropdown-item cursor-pointer py-2"
						   *ngFor="let customer of customerSearchResults"
						   (click)="selectCustomer(customer)">
							<div class="d-flex flex-column">
								<span class="fw-bold">{{ getCustomerDisplayName(customer) }}</span>
								<small class="text-muted">{{ customer.email }}</small>
							</div>
						</a>

						<!-- No Results -->
						<div class="dropdown-item text-center py-3 text-muted"
							 *ngIf="!isCustomerSearching && customerSearchResults.length === 0">
							No customers found
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Filter Section -->
	<div class="card-body border-bottom filter-section" *ngIf="showFilterSection">
		<form [formGroup]="filterForm" class="row g-3">
			<div class="col-md-3">
				<label class="form-label">By Stock Number</label>
				<input type="text" class="form-control form-control-sm" formControlName="stockNumber" placeholder="Enter Stock Number">
			</div>
			<div class="col-md-3">
				<label class="form-label">By Balance Finalized Date (From)</label>
				<input type="date" class="form-control form-control-sm" formControlName="balanceFinalizedDateFrom">
			</div>
			<div class="col-md-3">
				<label class="form-label">By Balance Finalized Date (To)</label>
				<input type="date" class="form-control form-control-sm" formControlName="balanceFinalizedDateTo">
			</div>
			<div class="col-md-3">
				<label class="form-label">By Keyword</label>
				<input type="text" class="form-control form-control-sm" formControlName="keyword" placeholder="Enter Keyword">
			</div>
			<div class="col-12">
				<div class="d-flex gap-2">
					<button type="button" class="btn btn-danger btn-sm" (click)="applyFilters()">
						<i class="ki-duotone ki-magnifier fs-2">
							<span class="path1"></span>
							<span class="path2"></span>
						</i>
						Search
					</button>
					<button type="button" class="btn btn-secondary btn-sm" (click)="clearFilters()">
						<i class="ki-duotone ki-cross fs-2">
							<span class="path1"></span>
							<span class="path2"></span>
						</i>
						Clear
					</button>
				</div>
			</div>
		</form>
	</div>

	<div class="card-body pt-0">
		<div class="fw-row row">
			<div class="col-md-7">
				<!-- Save Button -->
				<div class="mb-3" *ngIf="hasAllocations">
					<button type="button" class="btn btn-primary" [disabled]="isLoading" (click)="saveAllocations()">
            <span class="indicator-label" *ngIf="!isLoading"></span>

						<i class="ki-duotone ki-check fs-2">
							<span class="path1"></span>
							<span class="path2"></span>
						</i>
						Save Allocations
					</button>
				</div>

				<app-invoice-listing #invoiceListing [customerId]="customerId" [customerCurrency]="clientData?.currency_type" [activeFilters]="activeFilters" (allocationChanged)="onAllocationChanged($event)" (allocationDeleted)="onAllocationDeleted()"></app-invoice-listing>
			</div>
			<div class="col-md-5">
				<app-deposit-listing #depositListing [customerId]="customerId" (depositSelected)="onDepositSelected($event)"></app-deposit-listing>
			</div>
		</div>
	</div>
</div>
